import { Component, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NxDropdownComponent, NxDropdownItemComponent } from '@allianz/ng-aquila/dropdown';
import { NxFormfieldComponent } from '@allianz/ng-aquila/formfield';
import { availableLangs, AvailableLangs } from '../../model/translaco.config';

const LANGUAGE_LABELS: Record<AvailableLangs, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  it: 'Italiano',
  nl: 'Nederlands',
};

@Component({
  selector: 'app-dropdown-language',
  imports: [NxDropdownComponent, NxDropdownItemComponent, NxFormfieldComponent],
  templateUrl: './dropdown-language.component.html',
  styleUrl: './dropdown-language.component.css',
})
export class DropdownLanguageComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly languages = availableLangs.map((code) => ({
    code,
    label: LANGUAGE_LABELS[code],
  }));

  get selectedLang(): AvailableLangs {
    return this.translocoService.getActiveLang() as AvailableLangs;
  }

  set selectedLang(lang: AvailableLangs) {
    this.onLanguageChange(lang);
  }

  onLanguageChange(lang: AvailableLangs): void {
    this.translocoService.setActiveLang(lang);
    document.documentElement.lang = lang;
  }
}
